import React from 'react';
import clsx from 'clsx';

import RichText from '@common/RichText';
import TitleBorder from '@common/TitleBorder';

const ColouredTextBlock = ({ data, className }) => {
  const {
    title,
    text
  } = data;
  return (
    <div className={clsx('d-flex flex-column ms-1 ms-md-0 mb-3 py-2', className)} >
      <div className='px-1 position-relative'>
        <TitleBorder />
        <p className='fs-32 mb-0'>{title}</p>
      </div>
      <RichText p='mt-3 mb-0 px-1' json={text}/>
    </div>
  )
}

export default ColouredTextBlock
